<template lang="pug">
.step-equipo
  // Buscador de Equipos
  .search-section.mb-4.position-relative
    b-form-group(label="Modelo" label-for="search-equipo" class="mb-0")
      b-input-group.seamless-input-group
        b-input-group-prepend
          b-input-group-text.bg-white.border-right-0
            b-spinner(small v-if="loading")
            b-icon(v-else icon="search" style="color: #525252 !important;")
        b-form-input#search-equipo.border-left-0(
          v-model="searchQuery"
          placeholder="Escribe nombre del Modelo"
          @focus="cargarIniciales"
          @input="onInput"
          @blur="cerrarDropdown"
          autocomplete="off"
        )
    .dropdown-results(v-if="showDropdown")
      .list-group
        template(v-if="resultados.length > 0")
          .list-group-item.list-group-item-action(
            v-for="item in resultados"
            :key="item.modelo_id"
            @mousedown.prevent="agregarEquipo(item)"
          )
            .d-flex.justify-content-between.align-items-center
              div
                span.font-weight-bold {{ item.modelo }}
                br
                small.text-muted {{ item.stock }} disponible{{ item.stock !== 1 ? 's' : '' }}
              span.text-blue-accent.font-weight-bold {{ item.precio_tienda | formatCurrency }}
        .list-group-item.text-muted(v-else-if="!loading")
          small No hay equipos disponibles para la tienda

  // Equipos Seleccionados (Formulario de cada uno)
  .selected-equipments.mt-4(v-if="form.items.length > 0")
    .equipment-card.mb-4(v-for="(item, index) in form.items" :key="index")
      .card-header-product.mb-3
        .d-flex.align-items-center.justify-content-between
          .d-flex.align-items-center
            .product-image.mr-3
              img(v-if="item.imagen" :src="item.imagen" alt="product")
              b-icon(v-else icon="laptop" font-scale="2")
            .product-info
              p.product-description.mb-1 {{ item.modelo }}
              p.product-price.mb-0 {{ item.precio | formatCurrency }}
          b-button(variant="link" class="text-danger p-0" @click="removerEquipo(index)")
            b-icon(icon="trash")

      b-row
        b-col(md="6")
          b-form-group(label="Cantidad")
            b-form-input(
              v-model.number="item.cantidad"
              type="number"
              min="1"
              @change="onCantidadChange(item)"
            )
            small.text-danger(v-if="item.cantidad > item.stock") La cantidad supera el stock disponible

        b-col(md="6")
          b-form-group(label="Porcentaje de Descuento")
            b-input-group(append="%")
              b-form-input(
                v-model.number="item.descuento"
                type="number"
                min="0"
                max="100"
                placeholder="Opcional"
                @change="updateTotals"
              )

      //- Selectores por cada unidad
      b-form-group(
        v-for="(sel, unitIdx) in item.seleccionesEquipo"
        :key="unitIdx"
        :label="item.seleccionesEquipo.length > 1 ? `Unidad ${unitIdx + 1} — Serie/OT` : 'Serie / OT'"
      )
        b-form-select(
          v-model="sel.equipoId"
          :options="opcionesEquipo(item, unitIdx)"
          :disabled="item.equipoIds.length === 1"
        )
        small.text-muted(v-if="item.equipoIds.length === 1")
          | Serie única disponible: {{ item.equipoIds[0].serie }}

      b-form-group(label="Tipo de Garantía")
        b-form-select(
          v-model="item.tipo_garantia"
          :options="getAvailableWarranties(item)"
          @change="updateTotals"
        )

  // Botón Agregar otro equipo
  .add-another-section.mt-3(v-if="form.items.length > 0")
    b-button(variant="link" class="p-0 text-blue-accent d-flex align-items-center" @click="resetSearch")
      b-icon.mr-2(icon="plus-circle-fill")
      span Agregar otro Equipo

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Step2Equipo',
  props: {
    form: {
      type: Object,
      required: true,
    },
    $v: {
      type: Object,
      required: true,
    },
    allWarranties: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchQuery: '',
      loading: false,
      resultados: [],
      showDropdown: false,
      debounceTimer: null,
    }
  },
  methods: {
    ...mapActions('OVEStore', ['listEquiposDisponibles']),

    getAvailableWarranties(item) {
      const options = [{ value: 'normal', text: 'Sin garantía extendida' }]

      if (!item.permite_garantia) return options

      const applicable = this.allWarranties.filter((g) => {
        const { precio } = item
        return precio >= g.precio_minimo && precio <= g.precio_maximo
      })

      applicable.forEach((g) => {
        options.push({
          value: g.id,
          text: `${g.nombre} (+${this.$options.filters.formatCurrency(
            g.precio
          )})`,
        })
      })

      return options
    },

    async cargarIniciales() {
      if (this.resultados.length === 0) {
        await this.buscarEquipos('')
      }
      this.showDropdown = true
    },

    onInput() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.buscarEquipos(this.searchQuery)
      }, 300)
    },

    async buscarEquipos(query) {
      this.loading = true
      try {
        const selectedIds = new Set(
          this.form.items.map((i) => i.modelo_id).filter(Boolean)
        )
        const res = await this.listEquiposDisponibles(query)
        this.resultados = res.filter((r) => !selectedIds.has(r.modelo_id))
        this.showDropdown = true
      } catch (error) {
        console.error('Error buscando equipos:', error)
      } finally {
        this.loading = false
      }
    },

    cerrarDropdown() {
      setTimeout(() => {
        this.showDropdown = false
      }, 150)
    },

    agregarEquipo(item) {
      const initEquipoId =
        item.equipo_ids.length === 1 ? item.equipo_ids[0].id : null
      const seleccionesEquipo = [{ equipoId: initEquipoId }]

      this.form.items.push({
        id: item.equipo_ids[0]?.id ?? null,
        modelo_id: item.modelo_id,
        equipoIds: item.equipo_ids,
        modelo: item.modelo,
        seleccionesEquipo,
        precio: item.precio_tienda,
        imagen: item.imagen_url,
        permite_garantia: item.permite_garantia,
        cantidad: 1,
        descuento: 0,
        tipo_garantia: 'normal',
        total: item.precio_tienda,
        stock: item.stock,
      })
      this.resultados = []
      this.searchQuery = ''
      this.showDropdown = false
      this.updateTotals()
    },

    removerEquipo(index) {
      this.form.items.splice(index, 1)
      this.updateTotals()
    },

    resetSearch() {
      this.searchQuery = ''
      this.resultados = []
      this.$nextTick(() => {
        const input = document.getElementById('search-equipo')
        if (input) input.focus()
      })
    },

    opcionesEquipo(item, unitIndex) {
      const elegidos = new Set(
        item.seleccionesEquipo
          .filter((s, i) => i !== unitIndex && s.equipoId !== null)
          .map((s) => s.equipoId)
      )

      const disponibles = item.equipoIds.filter((eq) => !elegidos.has(eq.id))

      const opciones = [
        { value: null, text: 'Cualquiera (primer disponible)' },
        ...disponibles.map((eq) => ({
          value: eq.id,
          text: `Serie: ${eq.serie} — OT #${eq.nro_ot}`,
        })),
      ]

      return opciones
    },

    sincronizarSelecciones(item) {
      const actual = item.seleccionesEquipo.length
      const nueva = item.cantidad || 1 // Fallback to 1 if empty or invalid

      if (nueva > actual) {
        for (let i = actual; i < nueva; i += 1) {
          item.seleccionesEquipo.push({ equipoId: null })
        }
      } else if (nueva < actual) {
        item.seleccionesEquipo.splice(nueva)
      }
    },

    onCantidadChange(item) {
      this.sincronizarSelecciones(item)
      this.updateTotals()
    },

    updateTotals() {
      this.form.items.forEach((item) => {
        const subtotal = item.precio * item.cantidad
        const discount =
          Math.floor((item.precio * item.descuento) / 100) * item.cantidad

        let precioGarantia = 0
        if (item.tipo_garantia !== 'normal') {
          const garantia = this.allWarranties.find(
            (g) => g.id === item.tipo_garantia
          )
          if (garantia) {
            precioGarantia = garantia.precio
          } else {
            precioGarantia = item.precio_garantia || 0
          }
        }

        item.total = subtotal - discount + precioGarantia * item.cantidad
      })
      this.$emit('update-totals')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.step-equipo {
  .dropdown-results {
    position: absolute;
    z-index: 1050;
    width: 100%;
    max-height: 320px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .text-blue-accent {
    color: #1d4ed8;
    font-weight: 500;
  }

  .equipment-card {
    background: white;
    border: 1px solid #444444;
    border-radius: 8px;
    padding: 20px;
  }

  .product-image {
    width: 68px;
    height: 68px;
    background-color: #f5f6fa;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }

  .product-description {
    font-size: 15px;
    color: #525252;
  }

  .product-price {
    font-size: 18px;
    font-weight: bold;
    color: #1d4ed8;
  }

  ::v-deep .form-group label {
    font-weight: bold;
    color: #23201c;
    font-size: 15px;
  }

  ::v-deep .form-control,
  ::v-deep .custom-select {
    height: 45px;
    border: 1px solid #525252;
    border-radius: 5px;

    &::placeholder {
      color: #525252;
    }
  }

  ::v-deep .input-group-text {
    border: 1px solid #525252;
    border-right: none;
    background-color: white;
  }
}
</style>
